"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageBodyTop = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _constants = require("../../../constants");
var _ReadinessCheck = require("../../ReadinessCheck");
var _JoinComponent = require("../JoinComponent.styled");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/**
 * PageBodyTop component renders the top section of the page body with status messages and warnings.
 * @param {string} currentPage - Current page being displayed
 * @param {string} checkStatus - Current status of the system check
 * @param {string[]} errors - Array of error messages
 * @param {string[]} warnings - Array of warning messages
 * @returns {JSX.Element|null} The top section of the page body
 */
var PageBodyTop = exports.PageBodyTop = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var currentPage = _ref.currentPage,
    checkStatus = _ref.checkStatus,
    errors = _ref.errors,
    warnings = _ref.warnings;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    showWarnings = _useState2[0],
    setShowWarnings = _useState2[1];
  var checkInProgress = checkStatus === _constants.JOIN_PAGE_STATUS.IN_PROGRESS;
  var hasErrors = errors.length > 0 && !checkInProgress;
  var hasWarnings = warnings.length > 0 && !checkInProgress;
  var hasNoIssues = !(hasErrors || hasWarnings) && !checkInProgress;
  if (checkInProgress) {
    return /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledSubtitle, null, /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledIconSpinner, {
      icon: _freeSolidSvgIcons.faSpinner,
      className: "fa-spin"
    }), " Checking your system for best performance...");
  }
  if (currentPage === _constants.JOIN_PAGE.SETTINGS) {
    return /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledSubtitle, null, "Choose your setup and check your devices to continue.");
  }
  if (currentPage === _constants.JOIN_PAGE.SYSTEM_CHECK && hasNoIssues) {
    return /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledSubtitle, null, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      color: "#206B4A",
      icon: _freeSolidSvgIcons.faCheckCircle
    }), " You're all set! Join when you're ready. You won\u2019t be seen or heard by the audience when you join.");
  }
  if (currentPage === _constants.JOIN_PAGE.SYSTEM_CHECK && hasErrors) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "pb-4"
    }, /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledSubtitle, null, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      color: "#DE2F1B",
      icon: _freeSolidSvgIcons.faExclamationCircle
    }), " You must fix these issues before joining Studio"), /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledIssueWrapper, null, errors.map(function (error) {
      return /*#__PURE__*/_react["default"].createElement(_JoinComponent.ReadinessCheckerMessagingWrapper, {
        key: error
      }, /*#__PURE__*/_react["default"].createElement(_ReadinessCheck.ReadinessCheckerMessaging, {
        name: error
      }));
    })));
  }
  if (currentPage === _constants.JOIN_PAGE.SYSTEM_CHECK && hasWarnings) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledSubtitle, {
      role: "button",
      onClick: function onClick() {
        return setShowWarnings(!showWarnings);
      },
      "data-testid": "show-warnings-button",
      $accordion: true
    }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Fix these issues for the best Studio experience"), /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledChevronIcon, {
      icon: _freeSolidSvgIcons.faChevronUp,
      $active: showWarnings
    })), /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledIssueWrapper, {
      $active: showWarnings
    }, warnings.map(function (warning) {
      return /*#__PURE__*/_react["default"].createElement(_JoinComponent.ReadinessCheckerMessagingWrapper, {
        key: warning
      }, /*#__PURE__*/_react["default"].createElement(_ReadinessCheck.ReadinessCheckerMessaging, {
        name: warning
      }));
    })));
  }
});
PageBodyTop.propTypes = {
  currentPage: _propTypes.string.isRequired,
  checkStatus: _propTypes.string.isRequired,
  errors: (0, _propTypes.arrayOf)(_propTypes.string).isRequired,
  warnings: (0, _propTypes.arrayOf)(_propTypes.string).isRequired
};